import React from "react";
import { FoldersGrid } from "./components";

const GalleryFolders = () => {
  return <FoldersGrid />;
};

export default GalleryFolders;
